import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-increment-grid',
  templateUrl: './increment-grid.component.html',
  styleUrls: ['./increment-grid.component.css']
})
export class IncrementGridComponent implements OnInit {
  title =" View Increment "
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/hrms/Increments/Increments/increment-grid/increment-grid.component.ts